import React from 'react'
import { useTranslation } from 'react-i18next'
import { MdCheckCircle, MdHighlightOff } from 'react-icons/md'
import { useProtectionWaiver } from 'hooks/tickets'
import { cardinal, mountainMeadow } from 'theme/colors'
import { IconIndicator } from 'components/IconIndicator'
function ProtectionWaiver() {
  const { t } = useTranslation()
  const isProtected = useProtectionWaiver()

  return (
    <>
      {isProtected ? (
        <IconIndicator icon={MdCheckCircle} iconColor={mountainMeadow} label={t('waivers.roadsideProtection')} />
      ) : (
        <IconIndicator icon={MdHighlightOff} iconColor={cardinal} label={t('waivers.roadsideProtection')} />
      )}
    </>
  )
}

export default ProtectionWaiver
